import axios from "axios";
const jsonConfig = require("../../Config.json");

const OrganizationConfigEdit = async (payload, id) => {
  let allResponse = {}
  try {
    const response = await axios.put(
        jsonConfig.apiUrl + "organizationconfig/" + id,
        payload,
          {
            headers: {
              "x-functions-key": jsonConfig.key,
            },
          }
        );
      
      allResponse = response;
      return Promise.resolve(allResponse)
  }
  catch (error) {
    console.log("Error Invite Candidate", error);
      return Promise.reject(error)
  }
}

export default OrganizationConfigEdit;